import { render, staticRenderFns } from "./PauseButton.vue?vue&type=template&id=11f06798&scoped=true"
import script from "./PauseButton.vue?vue&type=script&lang=js"
export * from "./PauseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f06798",
  null
  
)

export default component.exports